// @generated by protoc-gen-es v1.3.0
// @generated from file admin/v1/identities.proto (package admin.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Group } from "./types/v1/group_pb.js";
import { ListMetadata } from "./types/v1/list_metadata_pb.js";
import { User } from "./types/v1/user_pb.js";
import { ExternalId } from "./types/v1/external_id_pb.js";

/**
 * @generated from message admin.v1.ListGroupsRequest
 */
export const ListGroupsRequest = proto3.makeMessageType(
  "admin.v1.ListGroupsRequest",
  () => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.CreateGroupRequest
 */
export const CreateGroupRequest = proto3.makeMessageType(
  "admin.v1.CreateGroupRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetGroupByIdRequest
 */
export const GetGroupByIdRequest = proto3.makeMessageType(
  "admin.v1.GetGroupByIdRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.DeleteGroupRequest
 */
export const DeleteGroupRequest = proto3.makeMessageType(
  "admin.v1.DeleteGroupRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.UpdateGroupRequest
 */
export const UpdateGroupRequest = proto3.makeMessageType(
  "admin.v1.UpdateGroupRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.LinkUsersToGroupRequest
 */
export const LinkUsersToGroupRequest = proto3.makeMessageType(
  "admin.v1.LinkUsersToGroupRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.UnlinkUsersFromGroupRequest
 */
export const UnlinkUsersFromGroupRequest = proto3.makeMessageType(
  "admin.v1.UnlinkUsersFromGroupRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.CreateGroupResponse
 */
export const CreateGroupResponse = proto3.makeMessageType(
  "admin.v1.CreateGroupResponse",
  () => [
    { no: 1, name: "group", kind: "message", T: Group },
  ],
);

/**
 * @generated from message admin.v1.GetGroupByIdResponse
 */
export const GetGroupByIdResponse = proto3.makeMessageType(
  "admin.v1.GetGroupByIdResponse",
  () => [
    { no: 1, name: "group", kind: "message", T: Group },
  ],
);

/**
 * @generated from message admin.v1.DeleteGroupResponse
 */
export const DeleteGroupResponse = proto3.makeMessageType(
  "admin.v1.DeleteGroupResponse",
  () => [
    { no: 1, name: "group", kind: "message", T: Group },
  ],
);

/**
 * @generated from message admin.v1.UpdateGroupResponse
 */
export const UpdateGroupResponse = proto3.makeMessageType(
  "admin.v1.UpdateGroupResponse",
  () => [
    { no: 1, name: "group", kind: "message", T: Group },
  ],
);

/**
 * @generated from message admin.v1.ListGroupsResponse
 */
export const ListGroupsResponse = proto3.makeMessageType(
  "admin.v1.ListGroupsResponse",
  () => [
    { no: 1, name: "groups", kind: "message", T: Group, repeated: true },
    { no: 2, name: "list_metadata", kind: "message", T: ListMetadata },
  ],
);

/**
 * @generated from message admin.v1.LinkUsersToGroupResponse
 */
export const LinkUsersToGroupResponse = proto3.makeMessageType(
  "admin.v1.LinkUsersToGroupResponse",
  () => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.UnlinkUsersFromGroupResponse
 */
export const UnlinkUsersFromGroupResponse = proto3.makeMessageType(
  "admin.v1.UnlinkUsersFromGroupResponse",
  () => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.UserLinkGroupResponse
 */
export const UserLinkGroupResponse = proto3.makeMessageType(
  "admin.v1.UserLinkGroupResponse",
  () => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.ListUsersRequest
 */
export const ListUsersRequest = proto3.makeMessageType(
  "admin.v1.ListUsersRequest",
  () => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.ListUsersResponse
 */
export const ListUsersResponse = proto3.makeMessageType(
  "admin.v1.ListUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 2, name: "list_metadata", kind: "message", T: ListMetadata },
  ],
);

/**
 * @generated from message admin.v1.CreateUserRequest
 */
export const CreateUserRequest = proto3.makeMessageType(
  "admin.v1.CreateUserRequest",
  () => [
    { no: 1, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "app_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "app_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "idp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "expire_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message admin.v1.CreateUserResponse
 */
export const CreateUserResponse = proto3.makeMessageType(
  "admin.v1.CreateUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
    { no: 2, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetUserByIdRequest
 */
export const GetUserByIdRequest = proto3.makeMessageType(
  "admin.v1.GetUserByIdRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetUserByIdResponse
 */
export const GetUserByIdResponse = proto3.makeMessageType(
  "admin.v1.GetUserByIdResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message admin.v1.DeleteUserRequest
 */
export const DeleteUserRequest = proto3.makeMessageType(
  "admin.v1.DeleteUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.DeleteUserResponse
 */
export const DeleteUserResponse = proto3.makeMessageType(
  "admin.v1.DeleteUserResponse",
  [],
);

/**
 * @generated from message admin.v1.UpdateUserRequest
 */
export const UpdateUserRequest = proto3.makeMessageType(
  "admin.v1.UpdateUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.UpdateUserResponse
 */
export const UpdateUserResponse = proto3.makeMessageType(
  "admin.v1.UpdateUserResponse",
  [],
);

/**
 * @generated from message admin.v1.GetMachineUserAuthTokenRequest
 */
export const GetMachineUserAuthTokenRequest = proto3.makeMessageType(
  "admin.v1.GetMachineUserAuthTokenRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetMachineUserAuthTokenResponse
 */
export const GetMachineUserAuthTokenResponse = proto3.makeMessageType(
  "admin.v1.GetMachineUserAuthTokenResponse",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.RefreshMachineUserAuthTokenRequest
 */
export const RefreshMachineUserAuthTokenRequest = proto3.makeMessageType(
  "admin.v1.RefreshMachineUserAuthTokenRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.RefreshMachineUserAuthTokenResponse
 */
export const RefreshMachineUserAuthTokenResponse = proto3.makeMessageType(
  "admin.v1.RefreshMachineUserAuthTokenResponse",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetUserExternalIdsRequest
 */
export const GetUserExternalIdsRequest = proto3.makeMessageType(
  "admin.v1.GetUserExternalIdsRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.GetUserExternalIdsResponse
 */
export const GetUserExternalIdsResponse = proto3.makeMessageType(
  "admin.v1.GetUserExternalIdsResponse",
  () => [
    { no: 1, name: "external_ids", kind: "message", T: ExternalId, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.MapUserToExternalIdRequest
 */
export const MapUserToExternalIdRequest = proto3.makeMessageType(
  "admin.v1.MapUserToExternalIdRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "app_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.MapUserToExternalIdResponse
 */
export const MapUserToExternalIdResponse = proto3.makeMessageType(
  "admin.v1.MapUserToExternalIdResponse",
  [],
);

/**
 * @generated from message admin.v1.DeleteExternalIdMappingRequest
 */
export const DeleteExternalIdMappingRequest = proto3.makeMessageType(
  "admin.v1.DeleteExternalIdMappingRequest",
  () => [
    { no: 1, name: "mapping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message admin.v1.DeleteExternalIdMappingResponse
 */
export const DeleteExternalIdMappingResponse = proto3.makeMessageType(
  "admin.v1.DeleteExternalIdMappingResponse",
  [],
);

